import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import filter from "./filter";
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

// Storeを生成
const store = new Vuex.Store({
  modules: {
    auth,
    filter
  },
  plugins: [
    createPersistedState({
      key: 'dashboard',
      storage: window.localStorage
    }),
  ]
})

export default store
